import { Outlet } from 'react-router-dom';
import { useAuth } from '@providers/context/AuthContext';
import { UserHeader } from '@widgets/user-header';
import { AdminHeader } from '@widgets/admin-header';

export const AdminLayout = () => {
    const { isAuth } = useAuth();

    return isAuth
        ? (
            <AdminHeader>
                <Outlet/>
            </AdminHeader>
        ) : (
            <Outlet/>
        );

};

export const UserLayout = () => {
    const { isAuth } = useAuth();

    return isAuth
        ? (
            <UserHeader>
                <Outlet/>
            </UserHeader>
        ) : (
            <Outlet/>
        );
};